import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { sendToAnalytics, reportWebVitals } from './utils/WebVitals';
import ImagePreloader, { CRITICAL_IMAGES } from './components/common/ImagePreloader';
import { Theme } from '@radix-ui/themes';
import '@radix-ui/themes/styles.css';
import './i18n/i18n';
import { initSpacingCssVars } from './styles/spacing';
import './stylex.css';
import './index.css';
import './styles/animations.css';
import './styles/fonts.css';

// Import components directly instead of lazy loading
import App from './App.tsx';

// Initialize spacing CSS variables
const ThemeInitializer = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    initSpacingCssVars();
  }, []);

  return <>{children}</>;
};

// Define routes with direct component imports
const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
]);

// Create the main application component
const AppWithProviders = () => (
  <React.StrictMode>
    <Theme accentColor="orange" grayColor="gray" radius="medium" scaling="100%">
      <ThemeInitializer>
        <ImagePreloader images={CRITICAL_IMAGES}>
          <RouterProvider router={router} />
        </ImagePreloader>
      </ThemeInitializer>
    </Theme>
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root')!).render(<AppWithProviders />);

// Web Vitals reporting
reportWebVitals(sendToAnalytics);
